;(function () {
  'use strict'

  angular
    .module('contrast.superadmin.path.constants', [])
    .constant('APPLICATIONS_PATH', '/superadmin/applications')
})()
